'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderWrapper = undefined;
var _jsxFileName = 'src/header-wrapper.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _glamorous = require('glamorous');
var _propTypes = require('prop-types');
var _lodash = require('lodash');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var HeaderWrapper = exports.HeaderWrapper = function (_Component) {
  _inherits(HeaderWrapper, _Component);
  function HeaderWrapper() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, HeaderWrapper);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderWrapper.__proto__ || Object.getPrototypeOf(HeaderWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.toggleMenu = function () {
      _this.setState({
        open: !_this.state.open
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(HeaderWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        sections = _props.sections,
        rest = _objectWithoutProperties(_props, ['sections']);
      return (
        // Do not allow width to make its way into the styles of the header. This will cause weird problems for pages with scrollbars.
        _react2.default.createElement(_glamorous.Header, Object.assign({}, (0, _lodash.omit)(rest, 'width'), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          },
          __self: this
        }), sections.map(function (_ref2) {
          var key = _ref2.key,
            render = _ref2.render;
          return _react2.default.createElement(_react.Fragment, {
            key: key,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 20
            },
            __self: _this2
          }, render(_this2.state.open, _this2.toggleMenu));
        }))
      );
    }
  }]);
  return HeaderWrapper;
}(_react.Component);
HeaderWrapper.propTypes = {
  sections: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    render: _propTypes.func,
    key: _propTypes.string
  }))
};
exports.default = HeaderWrapper;